
  import { initSidebarObserver } from '/assets/js/sidebar-observer.js';

  // Initialize sidebar observer for sections
  initSidebarObserver({
    sectionSelector: '.section',
    linkSelector: '.sidebar-nav a'
  });

  // Highlight all code blocks after page load
  if (typeof Prism !== 'undefined') {
    Prism.highlightAll();
  }

  // Add copy buttons to all code blocks
  document.querySelectorAll('.code-block').forEach(block => {
    const header = block.querySelector('.code-block-header');
    if (!header) return;

    const copyBtn = document.createElement('button');
    copyBtn.className = 'copy-btn';
    copyBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
      </svg>
      <span>Copy</span>
    `;
    header.appendChild(copyBtn);

    copyBtn.addEventListener('click', async () => {
      const codeContent = block.querySelector('code');
      if (!codeContent) return;

      const text = codeContent.textContent;

      try {
        await navigator.clipboard.writeText(text);
        copyBtn.classList.add('copied');
        copyBtn.querySelector('span').textContent = 'Copied!';

        setTimeout(() => {
          copyBtn.classList.remove('copied');
          copyBtn.querySelector('span').textContent = 'Copy';
        }, 2000);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    });
  });
